import { PopoverOrigin } from '../../popover';
import { TooltipPosition } from '../model/types';

export const getTooltipAnchorOrigin = (position: TooltipPosition): PopoverOrigin => {
  const origins: Record<TooltipPosition, PopoverOrigin> = {
    left: { horizontal: 'left', vertical: 'center' },
    top: { horizontal: 'center', vertical: 'top' },
    right: { horizontal: 'right', vertical: 'center' },
    bottom: { horizontal: 'center', vertical: 'bottom' },
    topLeft: { horizontal: 'left', vertical: 'top' },
    topRight: { horizontal: 'right', vertical: 'top' },
    bottomLeft: { horizontal: 'left', vertical: 'bottom' },
    bottomRight: { horizontal: 'right', vertical: 'bottom' },
  };

  return origins[position];
};

export const getTooltipTransformOrigin = (position: TooltipPosition): PopoverOrigin => {
  const origins: Record<TooltipPosition, PopoverOrigin> = {
    left: { horizontal: 'right', vertical: 'center' },
    top: { horizontal: 'center', vertical: 'bottom' },
    right: { horizontal: 'left', vertical: 'center' },
    bottom: { horizontal: 'center', vertical: 'top' },
    topLeft: { horizontal: 'left', vertical: 'bottom' },
    topRight: { horizontal: 'right', vertical: 'bottom' },
    bottomLeft: { horizontal: 'left', vertical: 'top' },
    bottomRight: { horizontal: 'right', vertical: 'top' },
  };

  return origins[position];
};
